
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 4H8C6.93913 4 5.92172 4.42143 5.17157 5.17157C4.42143 5.92172 4 6.93913 4 8V24C4 25.0609 4.42143 26.0783 5.17157 26.8284C5.92172 27.5786 6.93913 28 8 28H24C25.0609 28 26.0783 27.5786 26.8284 26.8284C27.5786 26.0783 28 25.0609 28 24V8C28 6.93913 27.5786 5.92172 26.8284 5.17157C26.0783 4.42143 25.0609 4 24 4ZM21.7333 12.8133L15.64 20.8133C15.5158 20.9747 15.3563 21.1054 15.1737 21.1956C14.9911 21.2857 14.7903 21.3328 14.5867 21.3333C14.3841 21.3344 14.184 21.2894 14.0015 21.2016C13.819 21.1138 13.6589 20.9856 13.5333 20.8267L10.28 16.68C10.1723 16.5417 10.0929 16.3835 10.0464 16.2145C9.99983 16.0455 9.98702 15.869 10.0087 15.695C10.0304 15.5211 10.0861 15.3531 10.1727 15.2006C10.2592 15.0482 10.375 14.9144 10.5133 14.8067C10.7927 14.5892 11.147 14.4916 11.4983 14.5354C11.6723 14.557 11.8403 14.6127 11.9927 14.6993C12.1451 14.7859 12.279 14.9017 12.3867 15.04L14.56 17.8133L19.6 11.1467C19.7068 11.0066 19.8402 10.8889 19.9924 10.8004C20.1447 10.7118 20.313 10.6542 20.4875 10.6306C20.6621 10.6071 20.8396 10.6182 21.0099 10.6633C21.1802 10.7084 21.3399 10.7865 21.48 10.8933C21.6201 11.0001 21.7377 11.1335 21.8263 11.2858C21.9148 11.4381 21.9725 11.6063 21.996 11.7809C22.0196 11.9554 22.0085 12.1329 21.9634 12.3032C21.9183 12.4735 21.8401 12.6333 21.7333 12.7733V12.8133Z","fill":"#78C882"}})])
          )
        }
      }
    